import React, { useContext } from 'react'
import { Route, Redirect, Switch } from 'react-router'
import { useSelector } from 'react-redux'
import { AppUrls } from 'common/AppUrls'
import { Layout } from 'components/layout/Layout'

import {
    Login,
    PasswordRecovery,
    Recents,
    Contacts,
    Settings,
    Dialpad,
    Account,
    ChangePassword,
    CallPreferences,
    SoundAndDevices,
    Help,
    About,
    Call,
    Conference,
    Keypad,
    MicrophonePermissionDenied,
    ConnectionLost,
    MultipleTabs,
    Integration
} from 'components/pages'

import { AppContext } from './Globals'
import { TransportState } from 'sip.js'
import { WhitelabelConfig, useRedirections } from 'hooks'

export function WebphoneRoute({
    path,
    component,
    withoutLayout = false,
    withoutFooter = false,
    authRequired = false,
    exact = false,
    disabled = false
}) {
    const redirectRoute = useRedirections({ authRequired, path, disabled })
    const route = (
        <Route
            path={path}
            exact={exact}
            render={(props) => <Layout {...{ component, withoutLayout, withoutFooter, path, ...props }} />}
        />
    )

    return redirectRoute || route
}

export const WebphoneRouter = () => {
    const { isUserAuthed } = useContext(AppContext)
    const isTrasportConnected = useSelector((state) => state.userAgent.transportStatus) === TransportState.Connected

    return (
        <Switch>
            <Redirect from="/" to={isUserAuthed ? AppUrls.dialpad : AppUrls.login} exact />
            <WebphoneRoute
                path={`${AppUrls.callTo}:number`}
                component={isTrasportConnected ? Call : Dialpad}
                authRequired
            />
            <WebphoneRoute path={AppUrls.recents} component={Recents} authRequired />
            <WebphoneRoute path={AppUrls.dialpad} component={Dialpad} authRequired />
            <WebphoneRoute path={AppUrls.contacts} component={Contacts} authRequired />
            <WebphoneRoute exact path={AppUrls.settings} component={Settings} authRequired />
            <WebphoneRoute exact path={AppUrls.account} component={Account} authRequired />
            <WebphoneRoute path={AppUrls.changePassword} component={ChangePassword} authRequired />
            <WebphoneRoute path={AppUrls.callPreferences} component={CallPreferences} authRequired />
            <WebphoneRoute path={AppUrls.soundAndDevices} component={SoundAndDevices} authRequired />
            <WebphoneRoute path={AppUrls.help} component={Help} authRequired disabled={WhitelabelConfig.settingsHelpDisabled}/>
            <WebphoneRoute path={AppUrls.about} component={About} authRequired disabled={WhitelabelConfig.settingsAboutDisabled}/>
            <WebphoneRoute path={AppUrls.integration} component={Integration} authRequired disabled={WhitelabelConfig.settingsIntegrationDisabled}/>
            <WebphoneRoute path={AppUrls.call} component={Call} withoutFooter authRequired />
            <WebphoneRoute path={AppUrls.callerInsights} component={Call} withoutFooter authRequired />
            <WebphoneRoute path={AppUrls.conference} component={Conference} withoutFooter authRequired />
            <WebphoneRoute path={AppUrls.keypad} component={Keypad} withoutFooter authRequired />
            <WebphoneRoute
                path={AppUrls.microphonePermissionDenied}
                component={MicrophonePermissionDenied}
                withoutLayout
                authRequired
            />
            <WebphoneRoute path={AppUrls.connectionLost} component={ConnectionLost} withoutLayout authRequired />
            <WebphoneRoute path={AppUrls.multipleTabsError} component={MultipleTabs} withoutLayout authRequired />
            <WebphoneRoute path={AppUrls.login} component={Login} withoutLayout />
            <WebphoneRoute path={AppUrls.passwordRecovery} component={PasswordRecovery} withoutLayout disabled={WhitelabelConfig.forgotPasswordDisabled}/>
            <WebphoneRoute path={AppUrls.resetPassword} component={PasswordRecovery} withoutLayout disabled={WhitelabelConfig.forgotPasswordDisabled} />
            <WebphoneRoute component={Login} withoutLayout />
        </Switch>
    )
}
